/**
 * GMV Product Card - Hover Effects
 * Handles image flip on hover
 */
(function() {
  'use strict';

  function setupGmvCardHoverEffects() {
    const productCards = document.querySelectorAll('.gmv-product-card');

    productCards.forEach((card) => {
      // Skip if already initialized
      if (card.dataset.hoverInit === 'true') return;
      
      const firstImage = card.querySelector('.gmv-card-img-first');
      const secondImage = card.querySelector('.gmv-card-img-second');

      if (firstImage) {
        card.dataset.hoverInit = 'true';
        
        // Set initial inline styles to ensure correct display
        if (secondImage) {
          secondImage.style.opacity = '0';
          secondImage.style.visibility = 'hidden';
          secondImage.style.transform = 'scale(1)';
        }
        firstImage.style.opacity = '1';
        firstImage.style.transform = 'scale(1)';
        
        // Remove existing listeners to avoid duplicates
        card.removeEventListener('mouseenter', card._handleMouseEnter);
        card.removeEventListener('mouseleave', card._handleMouseLeave);

        // Define handlers
        card._handleMouseEnter = function() {
          const thisFirstImg = card.querySelector('.gmv-card-img-first');
          const thisSecondImg = card.querySelector('.gmv-card-img-second');

          if (thisSecondImg) {
            // Flip to second image
            thisFirstImg.style.opacity = '0';
            thisSecondImg.style.opacity = '1';
            thisSecondImg.style.visibility = 'visible';
          }

          // Apply zoom to both
          if (thisFirstImg) {
            thisFirstImg.style.transform = 'scale(1.05)';
          }
          if (thisSecondImg) {
            thisSecondImg.style.transform = 'scale(1.05)';
          }
        };

        card._handleMouseLeave = function() {
          const thisFirstImg = card.querySelector('.gmv-card-img-first');
          const thisSecondImg = card.querySelector('.gmv-card-img-second');

          if (thisSecondImg) {
            // Flip back to first image
            thisFirstImg.style.opacity = '1';
            thisSecondImg.style.opacity = '0';
            thisSecondImg.style.visibility = 'hidden';
          }

          // Reset zoom
          if (thisFirstImg) {
            thisFirstImg.style.transform = 'scale(1)';
          }
          if (thisSecondImg) {
            thisSecondImg.style.transform = 'scale(1)';
          }
        };

        // Add event listeners
        card.addEventListener('mouseenter', card._handleMouseEnter);
        card.addEventListener('mouseleave', card._handleMouseLeave);
      }
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupGmvCardHoverEffects);
  } else {
    setupGmvCardHoverEffects();
  }

  // Also run after a short delay to catch dynamically loaded cards
  setTimeout(setupGmvCardHoverEffects, 100);
})();
